
/**
 * Class for listing all the available themes
 */
export class Themes {
/**
 * Default theme name
 */
public static default_theme = 'cf-default-theme';
/**
 * Object for listing the themes
 */
public static themes: any = {
    'Default-Theme': 'cf-default-theme',
    'Red-Theme': 'cf-red-theme',
    'Blue-Theme': 'cf-blue-theme',
    'Green-Theme': 'cf-green-theme',
    'Light-Theme': 'cf-light-theme',
    'Dark-Theme': 'cf-dark-theme',
    'Funky-Theme': 'cf-funky-theme',
  };
constructor() { }
}

function Themes_tsickle_Closure_declarations() {
/**
 * Default theme name
 * @type {?}
 */
Themes.default_theme;
/**
 * Object for listing the themes
 * @type {?}
 */
Themes.themes;
}

